import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BuyAbilityModal from "./BuyAbilityModal";
import BuyAbilityResultModal from "./BuyAbilityResultModal";
const CalculateYourBuyAbilityComp = () => {
const navigate = useNavigate();
const [showFormModal, setShowFormModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [buyAbilityData] = useState({
    homePrice: 100000,
    downPayment: 100000,
    monthlyPayment: 105,
    monthlyIncome: 0.00,
    dti: 0.00
  });

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const formatPercent = (value) => {
    return `${value.toFixed(2)}%`;
  };
const handleShowFormModal = () => setShowFormModal(true);
  const handleCloseFormModal = () => setShowFormModal(false);
  
  const handleShowResultModal = () => setShowResultModal(true);
  const handleCloseResultModal = () => setShowResultModal(false);

  const handleFormSubmitSuccess = () => {
    handleShowResultModal();
  };

  const handleEditInfo = () => {
    handleCloseResultModal();
    handleShowFormModal();
  };

  return (
    <>
    <section className="calculate-your-buy-ability-section common-padding">
      <Container>
        <Row className="align-items-center">
          {/* Left Column - Text Content */}
          <Col lg={6} md={12}>
            <div className="content-wrapper">
              <h2>
                Find homes in <br />
                your budget with <br />
                <span className="highlight">BuyAbility</span>
                <sup className="trademark">SM</sup>
              </h2>
              <p className="description">
                Monthly payment data: BuyAbility reviews your income and search on Real Estate. 
                Start now to see what you can afford in real time — and get pre-qualified with 
                Real Estate Home Loans when you're ready.
              </p>
            </div>
          </Col>

          {/* Right Column - Calculator Card */}
          <Col lg={6} md={12}>
            <div className="calculator-card-wrapper">
                <div className="card-header-text">
                    Your BuyAbility <sup className="trademark">SM</sup> today:
                </div>
                <Card className="buy-ability-card">
                    <Card.Body>
                        <Row className="metrics-row g-4">
                            {/* Home Price */}
                            <Col xs={12} md={8} className="br-1">
                            <div className="metric-box">
                                <div className="metric-value">
                                {formatCurrency(buyAbilityData.homePrice)}
                                </div>
                                <div className="metric-label">Home you can afford</div>
                            </div>
                            </Col>

                            {/* Down Payment */}
                            <Col xs={12} md={4}>
                            <div className="metric-box">
                                <div className="metric-value">
                                {formatCurrency(buyAbilityData.downPayment)}
                                </div>
                                <div className="metric-label">Down payment</div>
                            </div>
                            </Col>
                            </Row>
                            <hr />
                            <Row className="metrics-row g-4">
                            {/* Monthly Payment */}
                            <Col xs={12} md={4} className="br-1">
                            <div className="metric-box small">
                                <div className="metric-value">
                                {formatCurrency(buyAbilityData.monthlyPayment)}
                                </div>
                                <div className="metric-label">Est. payment</div>
                            </div>
                            </Col>

                            {/* Monthly Income */}
                            <Col xs={12} md={4} className="br-1">
                            <div className="metric-box small">
                                <div className="metric-value">
                                {formatPercent(buyAbilityData.monthlyIncome)}
                                </div>
                                <div className="metric-label">Monthly income</div>
                            </div>
                            </Col>

                            {/* DTI */}
                            <Col xs={12} md={4}>
                            <div className="metric-box small">
                                <div className="metric-value">
                                {formatPercent(buyAbilityData.dti)}
                                </div>
                                <div className="metric-label">DTI</div>
                            </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <div className="action-buttons">
                    <Button className="custom-bttn style-3 btn-black" onClick={handleShowFormModal}>
                    View your details
                    </Button>
                    <Button className="custom-bttn btn-red" onClick={() => navigate('/get-pre-qualified')}>
                    Get Prequalified
                    </Button>
                </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    {/* BuyAbility Modal */}
     <BuyAbilityModal 
        show={showFormModal} 
        handleClose={handleCloseFormModal}
        onSubmitSuccess={handleFormSubmitSuccess}
      />

      {/* BuyAbility Result Modal */}
      <BuyAbilityResultModal 
        show={showResultModal} 
        handleClose={handleCloseResultModal}
        handleEditInfo={handleEditInfo}
      />
    </>
  );
};

export default CalculateYourBuyAbilityComp;